import { useTranslations, useViewMode, ViewMode } from 'hooks'
import { VideoPlayer } from 'components'
import { AnyPlaybookType, PlaylistType, VideoOverlayDataType } from 'app/types'
import { DocViewAndVideoPlayer } from './DocViewAndVideoPlayer'
import { DocViewOnly } from './DocViewOnly'
import { isQG } from 'modules'
import { useMemo } from 'react'

type Props = {
    videos: Array<AnyPlaybookType>
    overlayData: VideoOverlayDataType
    playlist?: PlaylistType
}

export const ViewModeController = ({ videos, overlayData, playlist }: Props) => {
    const { viewMode } = useViewMode()

    const { currentVideoIndex, playbook, onLanguageChange, onChangeActiveVideo } = useTranslations(videos)

    const videoPlayer = useMemo(
        () => (
            <VideoPlayer
                videos={videos}
                overlayData={overlayData}
                currentVideoIndex={currentVideoIndex}
                playbook={playbook}
                onLanguageChange={onLanguageChange}
                onChangeActiveVideo={onChangeActiveVideo}
            />
        ),
        [videos, overlayData, currentVideoIndex, playbook, onLanguageChange, onChangeActiveVideo],
    )

    if (!isQG(playbook)) {
        return videoPlayer
    }

    switch (viewMode) {
        case ViewMode.VIDEO_AND_DOC:
            return (
                <DocViewAndVideoPlayer
                    videos={[playbook]}
                    overlayData={overlayData}
                    playlist={playlist}
                    currentVideoIndex={currentVideoIndex}
                    playbook={playbook}
                    onLanguageChange={onLanguageChange}
                    onChangeActiveVideo={onChangeActiveVideo}
                />
            )
        case ViewMode.DOC_ONLY:
            return (
                <DocViewOnly
                    playbook={playbook}
                    overlayData={overlayData}
                    currentVideoIndex={currentVideoIndex}
                    onLanguageChange={onLanguageChange}
                />
            )
        case ViewMode.VIDEO_ONLY:
        default:
            return videoPlayer
    }
}
